import { render, staticRenderFns } from "./ComboOptionSelector.vue?vue&type=template&id=08e878de&"
import script from "./ComboOptionSelector.vue?vue&type=script&lang=ts&"
export * from "./ComboOptionSelector.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports